import React from "react";

export default function RollingCommision() {
  return (
    <div _ngcontent-ng-c1893399002="" className="content sideLayout-fullmarket">
      <router-outlet _ngcontent-ng-c1893399002="" />
      <app-rolling-commission
        _nghost-ng-c14024624=""
        className="ng-star-inserted"
      >
        <div _ngcontent-ng-c14024624="" className="cardMain">
          <div _ngcontent-ng-c14024624="" className="row">
            <div
              _ngcontent-ng-c14024624=""
              className="col-sm-12 col-md-12 p-mobile-1"
            >
              <div
                _ngcontent-ng-c14024624=""
                className="card card-report card-accent-primary"
              >
                <div _ngcontent-ng-c14024624="" className="card-body row p-0">
                  <div
                    _ngcontent-ng-c14024624=""
                    className="col-md-12 betHistory"
                  >
                    <div _ngcontent-ng-c14024624="" className="row">
                      <div
                        _ngcontent-ng-c14024624=""
                        className="col-md-4 col-6 mb-3 slct-dat-con"
                      >
                        <div _ngcontent-ng-c14024624="" className="form-group">
                          <select
                            _ngcontent-ng-c14024624=""
                            id="datasourceSelect"
                            className="form-control custom-select ng-untouched ng-pristine ng-valid"
                          >
                            <option
                              _ngcontent-ng-c14024624=""
                              disabled=""
                              value=""
                            >
                              Data Source
                            </option>
                            <option _ngcontent-ng-c14024624="" value="LIVE">
                              LIVE DATA
                            </option>
                            <option _ngcontent-ng-c14024624="" value="BACKUP">
                              BACKUP DATA
                            </option>
                            <option _ngcontent-ng-c14024624="" value="OLD">
                              OLD DATA
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c14024624=""
                        className="col-md-4 col-6 mb-3 slct-date-con"
                      >
                        <div _ngcontent-ng-c14024624="" className="form-group">
                          <select
                            _ngcontent-ng-c14024624=""
                            id="sportSelect"
                            name="betType"
                            className="form-control custom-select ng-untouched ng-pristine ng-valid"
                          >
                            <option
                              _ngcontent-ng-c14024624=""
                              value=""
                              disabled=""
                            >
                              Select Sport
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={4}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Cricket{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={2}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Tennis{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={66102}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Casino{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={1}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Soccer{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={7}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Horse Racing{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={4339}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Greyhound Racing{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={27979456}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Kabaddi{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={7522}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Basketball{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={2378961}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Politics{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={66101}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Virtual Sports{" "}
                            </option>
                            <option
                              _ngcontent-ng-c14024624=""
                              value={66104}
                              className="ng-star-inserted"
                            >
                              {" "}
                              Lottery{" "}
                            </option>
                            {/**/}
                          </select>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c14024624=""
                        className="col-md-4 col-12 mb-2 slct-date-con slct-date-con-start"
                      >
                        <div
                          _ngcontent-ng-c14024624=""
                          className="form-group mb-0"
                        >
                          <div
                            _ngcontent-ng-c14024624=""
                            className="input-group"
                          >
                            <my-date-picker
                              _ngcontent-ng-c14024624=""
                              placeholder="Select Date"
                              name="mydate"
                              readOnly=""
                              autoComplete="off"
                              angular-mydatepicker=""
                              className="form-control my-date-picker ng-untouched ng-pristine ng-valid"
                            >
                              <div className="mydp" style={{ width: "100%" }}>
                                <div className="selectiongroup ng-star-inserted">
                                  <input
                                    ngtype="text"
                                    autoComplete="off"
                                    spellCheck="false"
                                    autoCorrect="off"
                                    className="selection inputnoteditable ng-untouched ng-pristine ng-valid ng-star-inserted"
                                    placeholder="Select Date"
                                    readOnly=""
                                    aria-label="Date input field"
                                    style={{ height: 34, fontSize: 14 }}
                                  />
                                  {/**/}
                                  <div
                                    className="selbtngroup"
                                    style={{ height: 34 }}
                                  >
                                    {/**/}
                                    {/**/}
                                    {/**/}
                                    <button
                                      type="button"
                                      className="btnpicker btnpickerenabled"
                                      aria-label="Open Calendar"
                                    >
                                      <span className="mydpicon icon-mydpcalendar" />
                                    </button>
                                  </div>
                                </div>
                                {/**/}
                                {/**/}
                              </div>
                            </my-date-picker>
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c14024624=""
                        className="col-md-4 col-12 date-con slct-date-con slct-date-con-end"
                      >
                        <div
                          _ngcontent-ng-c14024624=""
                          className="form-group mb-0"
                        >
                          <div
                            _ngcontent-ng-c14024624=""
                            className="input-group"
                          >
                            <my-date-picker
                              _ngcontent-ng-c14024624=""
                              placeholder="Select Date"
                              name="mydate"
                              readOnly=""
                              autoComplete="off"
                              angular-mydatepicker=""
                              className="form-control my-date-picker ng-untouched ng-pristine ng-valid"
                            >
                              <div className="mydp" style={{ width: "100%" }}>
                                <div className="selectiongroup ng-star-inserted">
                                  <input
                                    ngtype="text"
                                    autoComplete="off"
                                    spellCheck="false"
                                    autoCorrect="off"
                                    className="selection inputnoteditable ng-untouched ng-pristine ng-valid ng-star-inserted"
                                    placeholder="Select Date"
                                    readOnly=""
                                    aria-label="Date input field"
                                    style={{ height: 34, fontSize: 14 }}
                                  />
                                  {/**/}
                                  <div
                                    className="selbtngroup"
                                    style={{ height: 34 }}
                                  >
                                    {/**/}
                                    {/**/}
                                    {/**/}
                                    <button
                                      type="button"
                                      className="btnpicker btnpickerenabled"
                                      aria-label="Open Calendar"
                                    >
                                      <span className="mydpicon icon-mydpcalendar" />
                                    </button>
                                  </div>
                                </div>
                                {/**/}
                                {/**/}
                              </div>
                            </my-date-picker>
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c14024624=""
                        className="col-md-4 col-6 mt-1 slct-date-con slct-date-con-btn"
                      >
                        <button
                          _ngcontent-ng-c14024624=""
                          type="button"
                          className="btn btn-primary"
                          disabled=""
                        >
                          <strong _ngcontent-ng-c14024624="">
                            Get Commission
                          </strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div _ngcontent-ng-c14024624="" className="row">
            <div
              _ngcontent-ng-c14024624=""
              className="col-sm-12 col-md-12 p-mobile-1"
            >
              <div
                _ngcontent-ng-c14024624=""
                className="card card-accent-primary card-accent-primary-mobile"
              >
                <div
                  _ngcontent-ng-c14024624=""
                  className="card-header account-detail-head"
                >
                  <span _ngcontent-ng-c14024624="" className="roll-spn">
                    Rolling Commission
                  </span>
                </div>
                <div
                  _ngcontent-ng-c14024624=""
                  className="card-body account-stat-body"
                >
                  <div _ngcontent-ng-c14024624="" className="row rowtwo">
                    <div
                      _ngcontent-ng-c14024624=""
                      className="col-md-12 p-mobile-0"
                    >
                      <table
                        _ngcontent-ng-c14024624=""
                        className="row-border no-footer table table-hover table-responsive table-bordered t-two"
                      >
                        <thead _ngcontent-ng-c14024624="">
                          <tr _ngcontent-ng-c14024624="">
                            <th
                              _ngcontent-ng-c14024624=""
                              className="text-center"
                            >
                              Type
                            </th>
                            <th
                              _ngcontent-ng-c14024624=""
                              className="text-center"
                            >
                              Total Stack
                            </th>
                            <th
                              _ngcontent-ng-c14024624=""
                              className="text-center"
                            >
                              Total Commission
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          _ngcontent-ng-c14024624=""
                          className="ng-star-inserted"
                        >
                          <tr
                            _ngcontent-ng-c14024624=""
                            className="text-center ng-star-inserted"
                          >
                            <td
                              _ngcontent-ng-c14024624=""
                              style={{ textTransform: "capitalize" }}
                            >
                              MATCH_ODDS
                            </td>
                            <td _ngcontent-ng-c14024624="">100</td>
                            <td _ngcontent-ng-c14024624="">0</td>
                          </tr>
                          <tr
                            _ngcontent-ng-c14024624=""
                            className="text-center ng-star-inserted"
                          >
                            <td
                              _ngcontent-ng-c14024624=""
                              style={{ textTransform: "capitalize" }}
                            >
                              FANCY
                            </td>
                            <td _ngcontent-ng-c14024624="">200</td>
                            <td _ngcontent-ng-c14024624="">0</td>
                          </tr>
                          {/**/}
                        </tbody>
                        {/**/}
                        {/**/}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-rolling-commission>
      {/**/}
    </div>
  );
}
